import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategoryGrid from './components/CategoryGrid';
import AIBuyingGuide from './components/AIBuyingGuide';
import FeaturedProducts from './components/FeaturedProducts';
import WhyChooseUs from './components/WhyChooseUs';
import ShippingBenefits from './components/ShippingBenefits';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <main className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <TrustBar />
      <CategoryGrid />
      <AIBuyingGuide />
      <FeaturedProducts />
      <WhyChooseUs />
      <ShippingBenefits />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
